'use client';

import ky from 'ky';
import Cookies from 'universal-cookie';

import { COOKIE_USER_TOKEN } from 'src/constants/cookie.constants';
import { ProductDetailsPayload } from 'src/types/ProductDetail.type';

const cookies = new Cookies();

/**
 * Client-side function to fetch order details
 */
export const getOrderDetailClient = async (id: string): Promise<any> => {
  const baseUrl = process.env.REACT_APP_AUTH_BASE_API_URL || '';

  const token = cookies.get(COOKIE_USER_TOKEN);
  if (!token) {
    throw new Error('Authentication token not found');
  }

  const url = `${baseUrl}/me/orders/${id}`;

  const response = await ky.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    timeout: 15000,
  });

  return response.json();
};

/**
 * Client-side function to fetch vehicle/product details
 */
export const getVehicleByKeyClient = async (sku: string): Promise<ProductDetailsPayload> => {
  const baseUrl = process.env.REACT_APP_BIZ_API_URL || '';

  const url = `${baseUrl}/vehicles/${sku}`;

  const response = await ky.get(url, {
    headers: {
      'Content-Type': 'application/pdp+json',
    },
    timeout: 15000,
  });

  return response.json();
};

/**
 * Client-side function to get order and product data
 */
export const getOrderDataClient = async (
  id: string,
): Promise<{
  orderData: any;
  productData: ProductDetailsPayload | null;
}> => {
  let productData: ProductDetailsPayload | null = null;
  const orderData: any = await getOrderDetailClient(id);

  if (orderData?.vehicle?.sku) productData = await getVehicleByKeyClient(orderData?.vehicle?.sku);

  return {
    orderData,
    productData,
  };
};
